import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';

export default class OverviewHelper {
  static getTimesForCalendarHeader (twentyFourHourTime) {
    const times = [];
    for (let i = 0; i <= 1410; i = i + 30) {
      const h = Math.floor(i / 60);
      const m = i % 60;
      if (twentyFourHourTime) {
        times.push(moment().hour(h).minute(m).format('H:mm'));
      } else {
        times.push(moment().hour(h).minute(m).format('h:mm a'));
      }
    }
    return times;
  }

  static timeToPercentThroughDay (time, calendarDate) {
    if (calendarDate && !DateHelper.dateMatch(time.format(), calendarDate)) {
      return 0;
    }
    const mins = parseInt(time.format('mm')) + (parseInt(time.format('HH')) * 60);
    return mins / 1440;
  }

  static scrollHorizontalCalendar (calendar, percent) {
    calendar.scrollLeft = (4800 * percent) - 100;
  }

  static scrollVerticalCalendar (calendar, percent) {
    calendar.scrollTop = (6720 * percent) - 100;
  }

  static scrollToTime (currentTime) {
    const calendar = document.querySelector('.calendar-scroll-target');
    const percent = OverviewHelper.timeToPercentThroughDay(moment(currentTime));
    if (calendar.classList.contains('horizontal')) OverviewHelper.scrollHorizontalCalendar(calendar, percent);
    if (calendar.classList.contains('vertical')) OverviewHelper.scrollVerticalCalendar(calendar, percent);
  }

  static scrollToPx (scrollLeft = 0, scrollTop = 0) {
    setTimeout(() => {
      document.querySelector('.calendar-scroll-target').scrollTo(scrollLeft, 0);
      window.scrollTo(0, scrollTop);
    }, 0);
  }
}
